import { injectToolCSS } from '../utils/cssGenerator'
import { ALL_ELEMENT_SELECTORS } from '../enum/Selectors'
import ToolConfig from '../types/ToolConfig'

export const adjustLineHeightConfig: ToolConfig = {
  id: 'line-height',
  selector: `html`,
  childrenSelector: ALL_ELEMENT_SELECTORS,
  styles: {
    'line-height': '3',
  },
}

export default function adjustLineHeight(enable = false) {
  injectToolCSS({
    ...adjustLineHeightConfig,
    enable,
  })
}
